import { render, staticRenderFns } from "./MedicalFiles.vue?vue&type=template&id=03266c93&scoped=true"
import script from "./MedicalFiles.vue?vue&type=script&lang=js"
export * from "./MedicalFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03266c93",
  null
  
)

export default component.exports